import { render } from "./nfd-analysis.vue?vue&type=template&id=e48bfb96&scoped=true"
import script from "./nfd-analysis.vue?vue&type=script&lang=js"
export * from "./nfd-analysis.vue?vue&type=script&lang=js"

import "./nfd-analysis.vue?vue&type=style&index=0&id=e48bfb96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48bfb96"]])

export default __exports__